(() => {
  if (customElements.get('custom-sort')) {
    return;
  }

  class CustomSort extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
      this.attachEvents();
    }

    init() {
      this.select = this.querySelector('select');
    }

    attachEvents() {
      this.select?.addEventListener('change', this.changeOption.bind(this));
    }

    changeOption() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);

      this.changeSortParameter(urlParams);
      this.changeVariantParameter(urlParams);

      this.redirect(urlParams.toString());
    }
    
    changeSortParameter(urlParams) {
      const hasSortByParameter = urlParams.has('sort_by')
  
      if (hasSortByParameter) {
        urlParams.delete('sort_by');
      }
  
      urlParams.set('sort_by', this.select.value);
    }

    changeVariantParameter(urlParams) {
      const hasVariantParameter = urlParams.has('variant')
  
      if (hasVariantParameter) {
        urlParams.delete('variant');
      }

      urlParams.set('variant', this.select.dataset.variantParameter);
    }

    redirect(parameters) {
      window.location.href = `${window.location.pathname}?${parameters}`;
    }
  }

  customElements.define('custom-sort', CustomSort);
})();